<template>
  <div>
    <b-modal id="shelf"
             header-bg-variant="primary"
             hide-footer
             body-bg-variant="dark"
             body-text-variant="white">
      <template class="bg-success" #modal-title>
        <span class="text-white">Choose shelf for this package <b-icon-bookshelf/></span>
      </template>
      <h3>{{ shelfBox.metaData || 'Select box to place' }}</h3>
      <b-form-select v-model="shelfBox.shelf"
                     :options="shelfOptions"
                     class="my-3 bg-dark text-light"
                     placeholder="Select shelf number"></b-form-select>
      <b-button class="mt-3 px-3 ml-1 bg-success float-right" @click="setLastLocation">
        SAVE
      </b-button>
      <b-button class="mt-3 px-3 bg-dark float-right" @click="$bvModal.hide('shelf')">
        Cancel
      </b-button>
    </b-modal>
    <b-row>
      <b-col class="mt-3 text-center">
        <h3>SEARCH ORDERS</h3>
      </b-col>
    </b-row>
    <b-row class="text-right mt-4 mb-3">
      <b-col cols="6">
        <b-form-input
          class="bg-dark text-white"
          @keyup.enter="getBoxes"
          v-model="search"
          placeholder="Search orders by metadata"></b-form-input>
      </b-col>
      <b-col cols="3" class="block text-left">
        <b-button @click="getBoxes" class="p-2" :disabled="search.length < 3">SEARCH <b-icon-search></b-icon-search></b-button>
      </b-col>
      <b-col cols="6">

      </b-col>
    </b-row>
    <b-overlay class="mt-3" :show="loading" rounded="sm" variant="dark">
    <b-row v-if="!boxes.length && !loading" class="text-center mt-5 bg-dark rounded">
      <b-col cols="12">
        <p class="p-5 w-100">
         Use the search box above to find packed orders by metadata (at least 3 characters).
        </p>
      </b-col>
    </b-row>
      <div class="orders-list">
        <div v-for="(row, i) in boxes" :key="i" class="order-card">
          <div :class="[getClassForMetadata(row), 'item-header d-flex align-items-center justify-content-between p-2 font-weight-bold rounded-top']">
            <div class="d-flex align-items-center">
              <b-icon-upc-scan @click="printQR(row.box)" class="pointer mr-2"></b-icon-upc-scan>
              <span v-if="getStatus(row.products[0]).label === 'NORWAY'" class="d-flex align-items-center mr-2">
          <b-icon-check
            v-if="isDelivered(row.products[0])"
            class="text-secondary mr-2"></b-icon-check>
          <b-icon-archive
            v-else
            @click="setAsDelivered(row.box)"
            class="pointer mr-2"></b-icon-archive>
        </span>
              <span
                v-b-tooltip.hover.top="'Ordered: ' + moment(row.products[0].addedAt).format('DD.MM.YYYY')"
              >
          {{ moment(row.box.packedAt).format('DD.MM.YYYY') }} - {{ row.box.metaData }}
        </span>
            </div>
            <span
              class="pointer text-right"
              @click="getStatus(row.products[0]).label=== 'NORWAY' && openBoxShelfDialog(row.box)"
              v-b-tooltip.hover.left="moment(getStatus(row.products[0]).timestamp).format('DD.MM.YYYY')"
            >
        {{ getStatus(row.products[0]).label }}
        <span v-if="getStatus(row.products[0]).label === 'NORWAY'">
          {{ row.box.lastLocation || '' }}
        </span>
      </span>
          </div>
          <table class="table table-hover table-dark mb-0">
            <tbody>
            <tr
              v-for="(product, y) in row.products"
              :key="y"
              :class="getRowClass(product)"
              v-b-tooltip.hover.right="product.notes ? stripHtmlTags(product.notes) : ''"
            >
              <td
                v-if="product.metaData === 'WORKSHOP'"
                @click="unloadBox(product._id)"
                class="p-2"
                style="width:40px"
              >
                <b-icon-upload class="pointer"></b-icon-upload>
              </td>
              <td class="p-2">{{ product.sku }}</td>
              <td class="p-2">{{ product.name }}</td>
              <td class="p-2">{{ product.ssku }}</td>
              <td class="p-2 text-center" style="width:70px">
                {{ product.count }}{{ product.replacedWithLocal && '-L' }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import fixed from '@/fixed';
import { metadataMapping } from '@/utils';
import axios from 'axios';
import moment from 'moment';

import { packageSticker } from '@/sticker';
import transport from '@/views/Transport.vue';

export default {
  components: {},
  data: () => ({
    loading: false,
    boxes: [],
    summary: {},
    search: '',
    selectedCategory: '',
    selectedDate: '',

    shelfOptions: [
      { value: null, text: 'Select a shelf number' },
      ...Array.from({ length: fixed.localShelfCount }, (_, i) => ({ value: `${i + 1}`, text: `${i + 1}` })),
    ],
    shelfBox: {
      packedAt: '',
      metaData: '',
      shelf: null,
    },

    moment,
  }),
  mounted() {},
  computed: {
    transport() {
      return transport;
    },
  },
  methods: {
    async getBoxes() {
      if (!this.search || this.search.length < 3) { return; }

      this.loading = true;
      const url = `${fixed.API_URL}/packed-orders`;
      try {
        const { data } = await axios.get(
          url,
          {
            withCredentials: true,
            params: { q: this.search },
          },
        );
        this.boxes = data || [];
      } catch (error) {
        this.$toast.error("can't fetch packages");
      }
      this.calculateSummary();
      this.loading = false;
    },
    async unloadBox(id) {
      if (!id) return;

      this.loading = true;
      try {
        await axios.put(`${fixed.API_URL}/poland/unload-box`, { id }, { withCredentials: true });
        await this.getBoxes();
        this.$toast.success('successfully unloaded box');
      } catch (error) {
        this.$toast.error('error while trying to unload box');
      }
      this.loading = false;
    },
    resetShelf() {
      this.shelfBox = {
        packedAt: '',
        metaData: '',
        shelf: '',
      };
    },
    openBoxShelfDialog(box) {
      this.shelfBox.metaData = box.metaData;
      this.shelfBox.packedAt = new Date(box.packedAt).toISOString();
      this.shelfBox.shelf = box.lastLocation || null;
      this.$bvModal.show('shelf');
    },
    async setLastLocation() {
      if (!this.shelfBox.packedAt || this.shelfBox.metaData === '' || !this.shelfBox.shelf) {
        this.$toast.error('Need shelf info to set');
        return;
      }

      this.loading = true;
      try {
        await axios.put(`${fixed.API_URL}/admin/set-package-shelf`, { ...this.shelfBox }, { withCredentials: true });
        this.resetShelf();
        this.$bvModal.hide('shelf');
        this.$toast.success('Shelf set successfully.');
        await this.getBoxes();
      } catch (err) {
        this.$toast.error(err?.response?.data ? err.response.data : 'error setting shelf for the box');
      }
      this.loading = false;
    },
    calculateSummary() {
      this.summary = {};
      if (!this.boxes.length) return;

      this.boxes.forEach((box) => {
        const cn = this.getClassForMetadata(box);
        box['category'] = cn; // eslint-disable-line
        this.summary[cn] = this.summary[cn] ? this.summary[cn] += 1 : 1;
      });
    },
    getClassForMetadata(order) {
      if (order.products[0].orderedFor) return 'bg-dark';
      const mapped = metadataMapping.find((m) => m.pattern.test(order.box.metaData));
      return mapped.getClass(order.products[0]?.deliveryMethod?.name);
    },
    getRowClass(row) {
      if (row.notes && !row.noteType) return 'bg-primary';
      if (row.notes && row.noteType === 1) return 'wrong-ean text-white';
      if (row.notes && row.noteType === 2) return 'unavailable-goods text-white';
      if (row.notes && row.noteType === 3) return 'goods-replaced-with text-dark';
      if (row.notes && row.noteType === 4) return 'bg-danger text-muted';

      return '';
    },
    stripHtmlTags(html) {
      const div = document.createElement('div');
      div.innerHTML = html;
      return div.textContent || div.innerText || '';
    },
    getStatus(order) {
      if (order?.transport && order.transport.poland && !order.transport.norway) {
        return {
          label: 'SENT',
          timestamp: order.transport.poland,
        };
      }
      if (order?.transport && order.transport.poland && order.transport.norway) {
        return {
          label: 'NORWAY',
          timestamp: order.transport.norway,
        };
      }

      return {
        label: 'READY',
        timestamp: order.packedAt,
      };
    },
    async printQR(box) {
      if (!box.metaData || !box.packedAt) {
        this.$toast.error('need package data to generate sticker');
        return;
      }
      this.loading = true;
      try {
        const { data } = await axios.put(
          `${fixed.API_URL}/qr-sticker`,
          { metaData: box.metaData, packedAt: box.packedAt },
          { withCredentials: true },
        );

        if (!data?.products || !data.products.length) {
          this.$toast.warning('There will be no products on the sticker');
          this.loading = false;
          return;
        }

        const iframe = packageSticker(data);
        iframe.onload = () => {
          this.$nextTick(() => {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
            document.body.removeChild(iframe);
          });
        };
      } catch (error) {
        this.$toast.error('error while trying to generate QR sticker');
      }
      this.loading = false;
    },
    isDelivered(product) {
      return product && product.transport && product.transport.delivered;
    },
    async setAsDelivered(box) {
      // eslint-disable-next-line
      const confirmed = confirm('Are you sure you want to set this package as delivered?');
      if (!confirmed) return;

      if (!box.metaData || !box.packedAt) {
        this.$toast.error('need package data to set as delivered');
        return;
      }

      this.loading = true;
      try {
        await axios.put(
          `${fixed.API_URL}/admin/set-as-delivered`,
          { metaData: box.metaData, packedAt: box.packedAt },
          { withCredentials: true },
        );
        this.$toast.success('Package set as delivered');
        await this.getBoxes();
      } catch (err) {
        this.$toast.error(err?.response?.data ? err.response.data : 'error while trying to set package as delivered');
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style>
.orders-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.order-card {
  border-radius: 5px;
  padding: 0.01rem;
  break-inside: avoid;
}
.item-header {
  min-height: 54px;
}

.regos-tape {
  background: #fada08;
  color: #222222;
}
.pickup-location {
  background: #f8f9fa;
  color: #222222;
}
.test-two-lines-tape {
  background-image: linear-gradient(to bottom, red 50%, blue 50%);
}
.test-three-lines-tape {
  background-image: linear-gradient(to bottom,
  #c050c9 0%, #c050c9 33.3%,
  #212126 33.3%, #212126 66.6%,
  #c050c9 66.6%, #c050c9 100%);
}
</style>
